import { createFileRoute } from '@tanstack/react-router'

import { PaginaInicio } from '@/features/inicio/pagina'

export const Route = createFileRoute('/$perfil/inicio')({
  component: Tela,
})

function Tela() {
  return <PaginaInicio />
}
